import { render } from "./VisitorTakePhoto.vue?vue&type=template&id=3966f5bd"
import script from "./VisitorTakePhoto.vue?vue&type=script&lang=js"
export * from "./VisitorTakePhoto.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__